App.WidgetGoals = (function ($) {
    'use strict';

    function Init(selector) {

        if (selector.length) {
            Buttons(selector);
            Mask(selector);
            $(window).on("resize", function () { Mask(selector); });
        }
    }

    function Buttons(selector) {

        const buttons = selector.find(".widget-goals-buttons a");

        buttons.on("mouseenter", function () {
            const guid = $(this).attr("data-guid");
            const image = selector.find(`.widget-goals-image[data-guid="${guid}"]`);
            image.stop().fadeIn(200).siblings().stop().fadeOut(200);
        });
    }

    function Mask(selector) {

        const bps = ["md", "sm", "xs"];
        const height = 120; // needs to/should match value in css

        const buttons = selector.find(".widget-goals-buttons");
        const content = selector.find(".widget-goals-buttons > ul");
        const trigger = selector.find(".widget-goals-buttons > button");

        if (bps.includes(ZagBreakpoints.GetBreakpoint())) {
            if (!buttons.hasClass("mask") && content.height() > height) {

                buttons.addClass("mask");
                trigger.on("click", function () {
                    $(this).attr("aria-expanded", $(this).attr("aria-expanded") !== "true");
                });
            }
            else if (buttons.hasClass("mask") && content.height() < height) {
                MaskDestroy(buttons);
            }
        }
        else {
            MaskDestroy(buttons);
        }
    }

    function MaskDestroy(buttons) {
        buttons.removeClass("mask");
    }

    return {
        Init: Init
    };

})(jQuery);